/* @generated */

// ../src/drawer/overlay/drawer.tsx
import * as React3 from "react";
import cls2 from "classnames";
import { autoUpdate, offset, size, useFloating } from "@floating-ui/react";

// ../src/_global/useParentRef.tsx
import * as React from "react";
var useParentRef = () => {
  const [tracerElement, setTracerElement] = React.useState(null);
  const parentRef = React.useRef(null);
  const parentElement = React.useMemo(() => {
    if (tracerElement) {
      return tracerElement.parentElement;
    }
    return null;
  }, [tracerElement]);
  parentRef.current = parentElement;
  const renderedTracer = /* @__PURE__ */ React.createElement("div", { ref: (el) => setTracerElement(el), style: { display: "none" } });
  return [parentRef, renderedTracer];
};

// ../src/drawer/overlay/drawer.tsx
import { useIsomorphicLayoutEffect } from "@react-hookz/web";
import { ELEVATED_BASE_INDEX, Layer } from "@dropbox/dig-components/layer";

// ../src/drawer/drawer-utils.ts
import cls from "classnames";

// ../src/drawer/common.css.ts
import { createRuntimeFn as _7a468 } from "@vanilla-extract/recipes/createRuntimeFn";
var cookCommonDrawerAlignmentClassName = _7a468({ defaultClassName: "dig-1hq01rq0_21-7-0", variantClassNames: { direction: { horizontal: "dig-1hq01rq1_21-7-0", vertical: "dig-1hq01rq2_21-7-0" }, alignment: { start: "dig-1hq01rq3_21-7-0", end: "dig-1hq01rq4_21-7-0" } }, defaultVariants: {}, compoundVariants: [[{ direction: "horizontal", alignment: "start" }, "dig-1hq01rq5_21-7-0"], [{ direction: "horizontal", alignment: "end" }, "dig-1hq01rq6_21-7-0"], [{ direction: "vertical", alignment: "end" }, "dig-1hq01rq7_21-7-0"]] });
var cookCommonDrawerMotionClassName = _7a468({ defaultClassName: "dig-1hq01rqg_21-7-0", variantClassNames: { isOpen: { true: "dig-1hq01rqh_21-7-0", false: "dig-1hq01rqi_21-7-0" }, shouldAnimate: { true: "dig-1hq01rqj_21-7-0", false: "dig-1hq01rqk_21-7-0" } }, defaultVariants: {}, compoundVariants: [[{ isOpen: true, shouldAnimate: true }, "dig-1hq01rql_21-7-0"]] });
var cookCommonDrawerStartMotionClassName = _7a468({ defaultClassName: "dig-1hq01rq8_21-7-0", variantClassNames: { direction: { horizontal: "dig-1hq01rq9_21-7-0", vertical: "dig-1hq01rqa_21-7-0" }, alignment: { start: "dig-1hq01rqb_21-7-0", end: "dig-1hq01rqc_21-7-0" } }, defaultVariants: {}, compoundVariants: [[{ direction: "horizontal", alignment: "start" }, "dig-1hq01rqd_21-7-0"], [{ direction: "horizontal", alignment: "end" }, "dig-1hq01rqe_21-7-0"], [{ direction: "vertical", alignment: "end" }, "dig-1hq01rqf_21-7-0"]] });

// ../src/drawer/drawer-utils.ts
var alignmentMap = {
  left: "start",
  right: "end",
  bottom: "end"
};
var directionMap = {
  left: "horizontal",
  right: "horizontal",
  bottom: "vertical"
};
function getDrawerClassnames({
  isOpen,
  shouldAnimate = false,
  isElevated = false,
  alignment,
  omitMotionStyles
}) {
  const motionClass = omitMotionStyles ? null : cookCommonDrawerMotionClassName({
    shouldAnimate,
    isOpen
  });
  const startMotionClass = omitMotionStyles ? null : cookCommonDrawerStartMotionClassName({
    alignment: alignmentMap[alignment],
    direction: directionMap[alignment]
  });
  return cls(
    "dig-Drawer",
    cookCommonDrawerAlignmentClassName({
      alignment: alignmentMap[alignment],
      direction: directionMap[alignment]
    }),
    startMotionClass,
    motionClass,
    {
      "dig-Drawer--horizontal": alignment === "left" || alignment === "right",
      "dig-Drawer--vertical": alignment === "bottom",
      "dig-Drawer--isElevated": isElevated,
      "dig-Drawer--isOpen": isOpen,
      "dig-Drawer--shouldAnimate": shouldAnimate
    },
    `dig-Drawer--${alignment}Align`
  );
}

// ../src/drawer/drawer-motion.tsx
import React2 from "react";
import { Transition } from "react-transition-group";

// ../src/_global/forceReflow.ts
var forceReflow = (node) => node && node.scrollTop;

// ../src/drawer/drawer-motion.tsx
var ANIMATION_DURATION_IN_MILLISECONDS = 333;
var useOptionalCallback = (callback) => React2.useCallback(() => callback && callback(), [callback]);
var DrawerMotion = ({
  shouldOpen,
  shouldAnimate = true,
  children,
  onWillEnter,
  onWillOpen,
  onDidOpen,
  onWillClose,
  onDidClose,
  isTransient = false
}) => {
  const _addEndListener = React2.useCallback(
    (node, done) => {
      if (!shouldAnimate) {
        done();
        return;
      }
      if (node) {
        node.addEventListener(
          "transitionend",
          (event) => {
            if (event.target === node) {
              done();
            }
          },
          false
        );
      }
    },
    [shouldAnimate]
  );
  const _onWillEnter = useOptionalCallback(onWillEnter);
  const _onWillOpen = useOptionalCallback(onWillOpen);
  const _onDidOpen = useOptionalCallback(onDidOpen);
  const _onWillClose = useOptionalCallback(onWillClose);
  const _onDidClose = useOptionalCallback(onDidClose);
  const _onEnter = (node) => {
    _onWillOpen();
    _onWillEnter();
    return forceReflow(node);
  };
  return /* @__PURE__ */ React2.createElement(
    Transition,
    {
      in: shouldOpen,
      appear: true,
      timeout: {
        appear: shouldAnimate ? ANIMATION_DURATION_IN_MILLISECONDS : 0,
        enter: shouldAnimate ? ANIMATION_DURATION_IN_MILLISECONDS : 0,
        exit: shouldAnimate ? ANIMATION_DURATION_IN_MILLISECONDS : 0
      },
      addEndListener: _addEndListener,
      onEnter: _onEnter,
      onEntered: _onDidOpen,
      onExit: _onWillClose,
      onExited: _onDidClose,
      mountOnEnter: isTransient,
      unmountOnExit: isTransient
    },
    (state) => children(state === "entering" || state === "entered")
  );
};
DrawerMotion.displayName = "DrawerMotion";

// ../src/drawer/overlay/drawer.tsx
import { usePrefersReducedMotion } from "@dropbox/dig-foundations";

// ../src/drawer/overlay/drawer.css.ts
import { createRuntimeFn as _7a4682 } from "@vanilla-extract/recipes/createRuntimeFn";
var cookDrawerClassName = _7a4682({ defaultClassName: "dig-xbh5ai1_21-7-0", variantClassNames: { isOpen: { true: "dig-xbh5ai2_21-7-0" }, shouldAnimate: { true: "dig-xbh5ai3_21-7-0" } }, defaultVariants: {}, compoundVariants: [[{ isOpen: true, shouldAnimate: true }, "dig-xbh5ai4_21-7-0"]] });
var overlayClassName = "dig-xbh5ai0_21-7-0";

// ../src/drawer/overlay/drawer.tsx
var applyFn = ({ elements, rects }) => {
  Object.assign(elements.floating.style, {
    width: `${rects.reference.width}px`,
    height: `${rects.reference.height}px`
  });
};
var useOverlappingFloating = (anchorRef) => {
  const floating = useFloating({
    placement: "bottom",
    strategy: "absolute",
    whileElementsMounted: (reference, floating2, update) => autoUpdate(reference, floating2, update, {
      // This is required to ensure the positioning is updated after render
      // For some reason (in iFrames especially), the position will
      // get flubbed and won't show. This appears in the `Nested Overlapping <direction>
      // VRT tests
      animationFrame: true,
      // Don't use ResizeObserver
      elementResize: false
    }),
    middleware: [
      // Place to entirely overlap the parent
      size({
        apply: applyFn
      }),
      offset(({ rects }) => -rects.reference.height)
    ]
  });
  const { refs } = floating;
  useIsomorphicLayoutEffect(() => {
    refs.setReference(anchorRef.current);
  }, [refs.setReference, anchorRef.current]);
  return floating;
};
var getPositionTransform = (x, y) => {
  if (typeof x !== "number") {
    x = 0;
  }
  if (typeof y !== "number") {
    y = 0;
  }
  return `translate3d(${Math.round(x)}px,${Math.ceil(y)}px,0)`;
};
var OverlayDrawer = React3.forwardRef(
  ({
    alignment,
    isOpen,
    className,
    children,
    isPortaled,
    shouldAnimate: _shouldAnimate = true,
    width,
    height,
    style,
    onWillOpen,
    onDidOpen,
    onWillClose,
    onDidClose,
    anchorRef,
    ...rest
  }, ref) => {
    const [parentRef, tracerContent] = useParentRef();
    const context = useOverlappingFloating(anchorRef || parentRef);
    const { x, y, update, refs } = context;
    const { hasReducedMotion } = usePrefersReducedMotion();
    const shouldAnimate = _shouldAnimate && !hasReducedMotion;
    React3.useImperativeHandle(ref, () => ({
      update
    }));
    const _onWillEnter = React3.useCallback(() => {
      setTimeout(() => update(), 0);
    }, [update]);
    return /* @__PURE__ */ React3.createElement(React3.Fragment, null, tracerContent, /* @__PURE__ */ React3.createElement(
      Layer,
      {
        _elevateByZ: ELEVATED_BASE_INDEX,
        isPortaled,
        _preferAbsolute: isPortaled
      },
      /* @__PURE__ */ React3.createElement(
        DrawerMotion,
        {
          shouldOpen: isOpen,
          shouldAnimate,
          onWillEnter: _onWillEnter,
          onWillClose,
          onDidClose,
          onWillOpen,
          onDidOpen,
          isTransient: true
        },
        (isMotionOpen) => {
          const _className = cls2(
            "dig-OverlayDrawer",
            cookDrawerClassName({
              isOpen: isMotionOpen,
              shouldAnimate
            }),
            getDrawerClassnames({
              isOpen: isMotionOpen,
              isElevated: true,
              alignment,
              shouldAnimate
            }),
            className
          );
          return /* @__PURE__ */ React3.createElement(
            "div",
            {
              ref: refs.setFloating,
              className: cls2("dig-OverlayDrawer-overlay", overlayClassName),
              style: {
                top: "0",
                left: "0",
                transform: getPositionTransform(x, y)
              },
              ...rest
            },
            /* @__PURE__ */ React3.createElement(
              "div",
              {
                className: _className,
                style: {
                  ...style,
                  width: width ? width : void 0,
                  height: height ? height : void 0
                }
              },
              children
            )
          );
        }
      )
    ));
  }
);
OverlayDrawer.displayName = "OverlayDrawer";

// ../src/drawer/inline/drawer.tsx
import React6, { useEffect as useEffect2, useContext } from "react";

// ../src/drawer/inline/context.tsx
import * as React4 from "react";
var noop = () => {
};
var InlineDrawerFrameContext = React4.createContext({
  register: noop,
  update: noop,
  unregister: noop,
  frameRef: void 0
});

// ../src/drawer/inline/useSynchronizedMotion.tsx
import * as React5 from "react";
import { EASE_ENTER, EASE_LEAVE } from "@dropbox/dig-components/motion";
import { animate } from "motion";
import { SKIP_ANIMATIONS } from "@dropbox/dig-components/motion";
var ANIMATION_DURATION = ANIMATION_DURATION_IN_MILLISECONDS / 1e3;
var getDrawerDefinition = ({
  alignment,
  currentState,
  setDurationToZero
}) => {
  const translateOpenState = "translate(0,0)";
  const translateCloseState = `translate(${alignment === "left" ? "-100%" : alignment === "right" ? "100%" : "0"}, ${alignment === "bottom" ? "100%" : "0"})`;
  if (currentState === "open") {
    return {
      keyFrames: {
        transform: [translateCloseState, translateOpenState]
      },
      options: {
        duration: setDurationToZero ? 0 : ANIMATION_DURATION,
        ease: EASE_ENTER,
        at: 0
      }
    };
  } else {
    return {
      keyFrames: {
        transform: [translateOpenState, translateCloseState]
      },
      options: {
        duration: setDurationToZero ? 0 : ANIMATION_DURATION,
        ease: EASE_LEAVE,
        at: 0
      }
    };
  }
};
var getFrameDefinition = ({
  alignment,
  dimension,
  currentState,
  setDurationToZero
}) => {
  const marginOpenState = !dimension ? "0" : `${dimension}px`;
  const marginCloseState = "0";
  const heightOpenState = `calc(100% - ${dimension}px)`;
  const heightCloseState = "100%";
  if (currentState === "open") {
    const openKeyFrames = {
      marginLeft: [marginCloseState, alignment === "left" ? marginOpenState : marginCloseState],
      marginRight: [marginCloseState, alignment === "right" ? marginOpenState : marginCloseState],
      marginBottom: [marginCloseState, alignment === "bottom" ? marginOpenState : marginCloseState],
      height: [heightCloseState, alignment === "bottom" ? heightOpenState : heightCloseState]
    };
    return {
      keyFrames: openKeyFrames,
      options: {
        duration: setDurationToZero ? 0 : ANIMATION_DURATION,
        ease: EASE_ENTER,
        at: 0
      }
    };
  } else {
    const closeKeyFrames = {
      marginLeft: [alignment === "left" ? marginOpenState : marginCloseState, marginCloseState],
      marginRight: [alignment === "right" ? marginOpenState : marginCloseState, marginCloseState],
      marginBottom: [alignment === "bottom" ? marginOpenState : marginCloseState, marginCloseState],
      height: [alignment === "bottom" ? heightOpenState : heightCloseState, heightCloseState]
    };
    return {
      keyFrames: closeKeyFrames,
      options: {
        duration: setDurationToZero ? 0 : ANIMATION_DURATION,
        ease: EASE_LEAVE,
        at: 0
      }
    };
  }
};
var useSynchronizedMotion = ({
  frameRef,
  drawerRef,
  currentState,
  alignment,
  setDurationToZero,
  onTransitionStart,
  onTransitionComplete
}) => {
  const [isMotionRunning, setIsMotionRunning] = React5.useState(false);
  const [previousState, setPreviousState] = React5.useState(currentState);
  const runningAnimation = React5.useRef(null);
  React5.useEffect(() => {
    if (runningAnimation.current) {
      runningAnimation.current.complete();
      runningAnimation.current = null;
    }
    if (SKIP_ANIMATIONS) {
      return;
    }
    requestAnimationFrame(() => {
      if (!(frameRef == null ? void 0 : frameRef.current) || !(drawerRef == null ? void 0 : drawerRef.current)) {
        return;
      }
      const calculatedDimension = alignment === "bottom" ? drawerRef.current.getBoundingClientRect().height : drawerRef.current.getBoundingClientRect().width;
      const drawerDefinition = getDrawerDefinition({ alignment, currentState, setDurationToZero });
      const frameDefinition = getFrameDefinition({
        alignment,
        dimension: calculatedDimension,
        currentState,
        setDurationToZero
      });
      setIsMotionRunning(true);
      onTransitionStart && onTransitionStart({ currentState });
      runningAnimation.current = animate([
        [frameRef.current, frameDefinition.keyFrames, frameDefinition.options],
        [drawerRef.current, drawerDefinition.keyFrames, drawerDefinition.options]
      ]);
      runningAnimation.current.then(() => {
        runningAnimation.current = null;
        setPreviousState(currentState);
        setIsMotionRunning(false);
        if (frameRef.current || drawerRef.current) {
          onTransitionComplete && onTransitionComplete({ currentState });
        }
      });
    });
  }, [
    currentState,
    drawerRef,
    frameRef,
    onTransitionComplete,
    onTransitionStart,
    setDurationToZero,
    alignment
  ]);
  if (SKIP_ANIMATIONS) {
    if (currentState !== previousState) {
      setPreviousState(currentState);
      onTransitionStart && onTransitionStart({ currentState });
      onTransitionComplete && onTransitionComplete({ currentState });
    }
    return { isMotionRunning: false };
  }
  return {
    isMotionRunning: isMotionRunning || currentState !== previousState
  };
};

// ../src/drawer/inline/drawer.tsx
import cls3 from "classnames";
import { useResizeObserver } from "@react-hookz/web";

// ../src/_global/resize_observer_polyfill.ts
import { ResizeObserver as ResizeObserverPolyfill } from "@juggle/resize-observer";
var polyfillResizeObserverGlobally = () => {
  if ("ResizeObserver" in globalThis === false) {
    globalThis.ResizeObserver = ResizeObserverPolyfill;
  }
};

// ../src/drawer/inline/drawer.tsx
import { usePrefersReducedMotion as usePrefersReducedMotion2 } from "@dropbox/dig-foundations";
polyfillResizeObserverGlobally();
var InlineDrawer = ({
  alignment,
  isOpen,
  className,
  shouldAnimate: _shouldAnimate = true,
  children,
  onWillOpen,
  onDidOpen,
  onWillClose,
  onDidClose,
  width,
  height,
  style,
  ...rest
}) => {
  const { register, update, unregister, frameRef } = useContext(InlineDrawerFrameContext);
  const { hasReducedMotion } = usePrefersReducedMotion2();
  const shouldAnimate = _shouldAnimate && !hasReducedMotion;
  const divRef = React6.useRef(null);
  const [drawerRect, setRect] = React6.useState(
    // eslint-disable-next-line react-compiler/react-compiler
    divRef.current ? divRef.current.getBoundingClientRect() : null
  );
  useResizeObserver(divRef, (entry) => {
    setRect(entry.contentRect);
  });
  const dimension = drawerRect ? alignment === "bottom" ? drawerRect.height : drawerRect.width : -1;
  useEffect2(() => {
    update({
      alignment,
      dimension,
      shouldAnimate,
      isOpen
    });
  }, [update, shouldAnimate, alignment, isOpen, dimension]);
  useEffect2(() => {
    register();
    return () => unregister();
  }, [register, unregister]);
  const isVertical = alignment === "bottom";
  const sizedStyle = {
    ...style,
    width: !isVertical ? width : void 0,
    height: isVertical ? height : void 0
  };
  const _className = cls3(
    "dig-InlineDrawer",
    getDrawerClassnames({
      shouldAnimate,
      // Never set the isOpen state since animation is guided by
      // a parent in the DOM
      isOpen: false,
      alignment,
      omitMotionStyles: true
    }),
    className
  );
  const motionTransitionComplete = React6.useCallback(
    (args) => {
      const { currentState } = args;
      if (currentState === "open") {
        onDidOpen && onDidOpen();
      } else if (currentState === "close") {
        onDidClose && onDidClose();
      }
    },
    [onDidOpen, onDidClose]
  );
  const motionTransitionStart = React6.useCallback(
    (args) => {
      const { currentState } = args;
      if (currentState === "open") {
        onWillOpen && onWillOpen();
      } else if (currentState === "close") {
        onWillClose && onWillClose();
      }
    },
    [onWillOpen, onWillClose]
  );
  const { isMotionRunning } = useSynchronizedMotion({
    drawerRef: divRef,
    frameRef,
    currentState: isOpen ? "open" : "close",
    alignment,
    setDurationToZero: !_shouldAnimate,
    onTransitionStart: motionTransitionStart,
    onTransitionComplete: motionTransitionComplete
  });
  if (isMotionRunning || isOpen) {
    return /* @__PURE__ */ React6.createElement("div", { className: _className, ...rest, ref: divRef, style: sizedStyle }, children);
  } else {
    return null;
  }
};
InlineDrawer.displayName = "InlineDrawer";

// ../src/drawer/modal/drawer.tsx
import React7 from "react";
import cls4 from "classnames";
import { RemoveScroll } from "react-remove-scroll";
import { MODAL_BASE_INDEX, Layer as Layer2 } from "@dropbox/dig-components/layer";
import { FloatingFocusManager, useFloating as useFloating2 } from "@floating-ui/react";

// ../src/_global/constants.ts
var ESC_KEY = "Escape";
var buttonDataAttributeName = "data-dig-button";
var buttonDataSelector = `[${buttonDataAttributeName}]`;
var buttonContentDataAttributeName = "data-dig-button-content";
var buttonContentDataSelector = `[${buttonContentDataAttributeName}]`;
var splitButtonDataAttributeName = "data-dig-split-button";
var splitButtonDataSelector = `[${splitButtonDataAttributeName}]`;
var iconButtonDataAttributeName = "data-dig-icon-button";
var iconButtonDataSelector = `[${iconButtonDataAttributeName}]`;

// ../src/drawer/modal/drawer.tsx
import { usePrefersReducedMotion as usePrefersReducedMotion3 } from "@dropbox/dig-foundations";
import { useIsomorphicLayoutEffect as useIsomorphicLayoutEffect2 } from "@react-hookz/web";

// ../src/drawer/modal/drawer.css.ts
import { createRuntimeFn as _7a4683 } from "@vanilla-extract/recipes/createRuntimeFn";
var cookScrimClassName = _7a4683({ defaultClassName: "dig-1ybvosp1_21-7-0", variantClassNames: { isOpen: { true: "dig-1ybvosp2_21-7-0" }, shouldAnimate: { true: "dig-1ybvosp3_21-7-0" } }, defaultVariants: {}, compoundVariants: [] });
var modalDrawerClassName = "dig-1ybvosp0_21-7-0";

// ../src/drawer/modal/drawer.tsx
var ModalDrawer = ({
  alignment,
  isOpen,
  className,
  children,
  shouldAnimate: _shouldAnimate = true,
  width,
  height,
  style,
  onWillOpen,
  onDidOpen,
  onWillClose,
  onDidClose,
  onRequestClose,
  shouldCloseOnScrimClick = true,
  returnFocusRef,
  ...rest
}) => {
  const { context, refs } = useFloating2({ open: isOpen });
  const { hasReducedMotion } = usePrefersReducedMotion3();
  const shouldAnimate = _shouldAnimate && !hasReducedMotion;
  const handleClickOnScrim = (e) => {
    if (shouldCloseOnScrimClick && onRequestClose) {
      onRequestClose(e);
    }
  };
  const handleKeyDownOnLayer = (e) => {
    e.stopPropagation();
    if (e.key === ESC_KEY && onRequestClose) {
      onRequestClose(e);
    }
  };
  const handleDrawerMotionWillOpen = () => {
    setIsDrawerClosed(false);
    onWillOpen && onWillOpen();
  };
  const handleDrawerMotionDidClose = () => {
    setIsDrawerClosed(true);
    onDidClose && onDidClose();
  };
  const [isDrawerClosed, setIsDrawerClosed] = React7.useState(!isOpen);
  const shouldRenderDrawer = isOpen || !isDrawerClosed;
  useIsomorphicLayoutEffect2(() => {
    if (isOpen) {
      if (returnFocusRef && returnFocusRef.current) {
        refs.setReference(returnFocusRef.current);
      } else if (typeof document !== "undefined" && document.activeElement) {
        refs.setReference(document.activeElement);
      }
    }
  }, [isOpen, returnFocusRef == null ? void 0 : returnFocusRef.current]);
  return shouldRenderDrawer ? /* @__PURE__ */ React7.createElement(Layer2, { _elevateByZ: MODAL_BASE_INDEX, onKeyDown: handleKeyDownOnLayer }, /* @__PURE__ */ React7.createElement(RemoveScroll, null, /* @__PURE__ */ React7.createElement(
    DrawerMotion,
    {
      shouldOpen: isOpen,
      shouldAnimate,
      onWillOpen: handleDrawerMotionWillOpen,
      onDidOpen,
      onWillClose,
      onDidClose: handleDrawerMotionDidClose,
      isTransient: true
    },
    (isMotionOpen) => {
      const scrimCls = cls4(
        "dig-ModalDrawer-scrim",
        cookScrimClassName({
          isOpen: isMotionOpen,
          shouldAnimate
        }),
        {
          "dig-ModalDrawer-scrim--isOpen": isMotionOpen,
          "dig-ModalDrawer-scrim--shouldAnimate": shouldAnimate
        }
      );
      const contentClassName = cls4(
        "dig-ModalDrawer",
        modalDrawerClassName,
        getDrawerClassnames({
          isOpen: isMotionOpen,
          isElevated: true,
          alignment,
          shouldAnimate
        }),
        className
      );
      return /* @__PURE__ */ React7.createElement(React7.Fragment, null, /* @__PURE__ */ React7.createElement(
        "div",
        {
          className: scrimCls,
          "data-testid": "digModalDrawerScrim",
          onClick: handleClickOnScrim,
          tabIndex: -1,
          "aria-hidden": true
        }
      ), /* @__PURE__ */ React7.createElement(FloatingFocusManager, { context, initialFocus: 0 }, /* @__PURE__ */ React7.createElement(
        "div",
        {
          className: contentClassName,
          style: {
            ...style,
            width: width ? width : void 0,
            height: height ? height : void 0
          },
          ...rest,
          ref: refs.setFloating,
          role: "dialog",
          "aria-modal": "true"
        },
        children
      )));
    }
  ))) : null;
};
ModalDrawer.displayName = "ModalDrawer";

// ../src/drawer/inline/frame.tsx
import React9 from "react";
import cls5 from "classnames";

// ../src/drawer/inline/hooks.tsx
import * as React8 from "react";
var INITIAL_STATE = { numberOfDrawers: 0 };
var reducer = (state, action) => {
  const { numberOfDrawers, drawer } = state;
  switch (action.kind) {
    case "register":
      if (numberOfDrawers > 0) {
        throw new Error(
          "Inline Drawer was already created in within this Frame, and will not function accurately. Have you considered using nested Frames?"
        );
      }
      return {
        numberOfDrawers: numberOfDrawers + 1,
        drawer
      };
    case "update":
      const { drawer: drawerUpdate } = action;
      return {
        numberOfDrawers,
        drawer: {
          ...drawerUpdate
        }
      };
    case "unregister":
      return {
        numberOfDrawers: numberOfDrawers - 1
      };
  }
  return state;
};
var useInlineDrawer = () => {
  const [state, dispatch] = React8.useReducer(reducer, INITIAL_STATE);
  return {
    state,
    update: React8.useCallback(
      (drawer) => {
        dispatch({
          kind: "update",
          drawer
        });
      },
      [dispatch]
    ),
    register: React8.useCallback(() => {
      dispatch({
        kind: "register"
      });
    }, [dispatch]),
    unregister: React8.useCallback(() => {
      dispatch({
        kind: "unregister"
      });
    }, [dispatch])
  };
};
var selectDrawerRenderProps = (drawer) => {
  const dimension = drawer ? drawer.dimension : -1;
  return {
    isOpen: drawer ? drawer.isOpen && dimension !== -1 : false,
    shouldAnimate: drawer ? drawer.shouldAnimate : false,
    alignment: drawer ? drawer.alignment : "bottom"
  };
};

// ../src/drawer/inline/drawer.css.ts
var frameBodyStyle = "dig-iax92w1_21-7-0";
var frameStyle = "dig-iax92w0_21-7-0";

// ../src/drawer/inline/frame.tsx
var InlineDrawerFrame = ({
  children,
  className,
  withDrawer,
  ...rest
}) => {
  const {
    state: inlineDrawerState,
    register: registerDrawer,
    unregister: unregisterDrawer,
    update
  } = useInlineDrawer();
  const { drawer } = inlineDrawerState;
  const { isOpen, shouldAnimate, alignment } = selectDrawerRenderProps(drawer);
  const frameRef = React9.useRef(null);
  const frameClassName = cls5(
    "dig-InlineDrawer-frame",
    frameStyle,
    {
      "dig-InlineDrawer-frame--isOpen": isOpen
    },
    className
  );
  const bodyClassName2 = cls5("dig-InlineDrawer-frame-body", frameBodyStyle, {
    "dig-InlineDrawer-frame-body--shouldAnimate": shouldAnimate
  });
  return /* @__PURE__ */ React9.createElement(
    InlineDrawerFrameContext.Provider,
    {
      value: { register: registerDrawer, unregister: unregisterDrawer, update, frameRef }
    },
    /* @__PURE__ */ React9.createElement(
      "div",
      { className: frameClassName, ...rest },
      // We automatically place the drawer first semantically in the DOM if alignment is `left`
      alignment === "left" ? /* @__PURE__ */ React9.createElement(React9.Fragment, null, withDrawer, /* @__PURE__ */ React9.createElement("div", { ref: frameRef, className: bodyClassName2 }, children)) : /* @__PURE__ */ React9.createElement(React9.Fragment, null, /* @__PURE__ */ React9.createElement("div", { ref: frameRef, className: bodyClassName2 }, children), withDrawer)
    )
  );
};
InlineDrawerFrame.displayName = "InlineDrawerFrame";

// ../src/drawer/layout/layout.tsx
import * as React10 from "react";
import cls6 from "classnames";

// ../src/drawer/layout/layout.css.ts
import { createRuntimeFn as _7a4684 } from "@vanilla-extract/recipes/createRuntimeFn";
var bodyClassName = "dig-cllzv1a_21-7-0";
var bookendInnerClassName = "dig-cllzv19_21-7-0";
var containerClassName = "dig-cllzv10_21-7-0";
var cookFooterClassName = _7a4684({ defaultClassName: "dig-cllzv15_21-7-0", variantClassNames: { isBorderHidden: { false: "dig-cllzv16_21-7-0" }, hasCustomPaddingY: { false: "dig-cllzv17_21-7-0" }, hasCustomPaddingX: { false: "dig-cllzv18_21-7-0" } }, defaultVariants: {}, compoundVariants: [] });
var cookHeaderClassName = _7a4684({ defaultClassName: "dig-cllzv11_21-7-0", variantClassNames: { isBorderHidden: { false: "dig-cllzv12_21-7-0" }, hasCustomPaddingY: { false: "dig-cllzv13_21-7-0" }, hasCustomPaddingX: { false: "dig-cllzv14_21-7-0" } }, defaultVariants: {}, compoundVariants: [] });
var cookLayoutItemClassName = _7a4684({ defaultClassName: "dig-cllzv1d_21-7-0", variantClassNames: { width: { fill: "dig-cllzv1e_21-7-0", hug: "dig-cllzv1f_21-7-0" }, shift: { end: "dig-cllzv1g_21-7-0", start: "dig-cllzv1h_21-7-0" } }, defaultVariants: {}, compoundVariants: [] });
var layoutClassName = "dig-cllzv1b_21-7-0";

// ../src/drawer/layout/layout.tsx
var DrawerLayout = ({
  children,
  className,
  ...rest
}) => {
  const _className = cls6("dig-Drawer-layout", layoutClassName, className);
  return /* @__PURE__ */ React10.createElement("div", { className: _className, ...rest }, children);
};
DrawerLayout.displayName = "DrawerLayout";

// ../src/drawer/layout/container.tsx
import * as React11 from "react";
import cls7 from "classnames";
var DrawerContainer = ({
  children,
  className,
  ...rest
}) => {
  const _className = cls7("dig-Drawer-container", containerClassName, className);
  return /* @__PURE__ */ React11.createElement("div", { className: _className, ...rest }, children);
};

// ../src/drawer/layout/layout-item.tsx
import * as React12 from "react";
import cls8 from "classnames";
var DrawerLayoutItem = ({
  children,
  width = "hug",
  shift,
  className,
  ...rest
}) => {
  const _className = cls8(
    "dig-Drawer-layout-item",
    cookLayoutItemClassName({
      width,
      shift: shift === "left" ? "start" : shift === "right" ? "end" : void 0
    }),
    {
      "dig-Drawer-layout-item--shiftLeft": shift === "left",
      "dig-Drawer-layout-item--shiftRight": shift === "right",
      "dig-Drawer-layout-item--fill": width === "fill"
    },
    className
  );
  return /* @__PURE__ */ React12.createElement("div", { className: _className, ...rest }, children);
};
DrawerLayoutItem.displayName = "DrawerLayoutItem";

// ../src/drawer/layout/header.tsx
import * as React13 from "react";
import cls9 from "classnames";
import { atoms } from "@dropbox/dig-foundations";
var DrawerHeader = ({
  isBorderHidden = false,
  children,
  className,
  paddingX,
  paddingY,
  padding,
  ...rest
}) => {
  const customPadding = atoms({ paddingX, paddingY, padding });
  const hasCustomPaddingX = paddingX !== void 0 || padding !== void 0;
  const hasCustomPaddingY = paddingY !== void 0 || padding !== void 0;
  const _className = cls9(
    "dig-Drawer-header",
    customPadding,
    cookHeaderClassName({
      isBorderHidden,
      hasCustomPaddingX,
      hasCustomPaddingY
    }),
    {
      "dig-Drawer-header--borderBottom": !isBorderHidden
    },
    className
  );
  return /* @__PURE__ */ React13.createElement("div", { className: _className, ...rest }, /* @__PURE__ */ React13.createElement("div", { className: cls9("dig-Drawer-section", bookendInnerClassName) }, children));
};
DrawerHeader.displayName = "DrawerHeader";

// ../src/drawer/layout/footer.tsx
import * as React14 from "react";
import cls10 from "classnames";
import { atoms as atoms2 } from "@dropbox/dig-foundations";
var DrawerFooter = ({
  isBorderHidden = false,
  children,
  className,
  paddingX,
  paddingY,
  padding,
  ...rest
}) => {
  const customPadding = atoms2({ paddingX, paddingY, padding });
  const hasCustomPaddingX = paddingX !== void 0 || padding !== void 0;
  const hasCustomPaddingY = paddingY !== void 0 || padding !== void 0;
  const _className = cls10(
    "dig-Drawer-footer",
    customPadding,
    cookFooterClassName({
      isBorderHidden,
      hasCustomPaddingX,
      hasCustomPaddingY
    }),
    {
      "dig-Drawer-footer--borderTop": !isBorderHidden
    },
    className
  );
  return /* @__PURE__ */ React14.createElement("div", { className: _className, ...rest }, /* @__PURE__ */ React14.createElement("div", { className: cls10("dig-Drawer-section", bookendInnerClassName) }, children));
};
DrawerFooter.displayName = "DrawerFooter";

// ../src/drawer/layout/body.tsx
import * as React15 from "react";
import cls11 from "classnames";
var DrawerBody = ({
  children,
  className,
  ...rest
}) => {
  const _className = cls11("dig-Drawer-body", bodyClassName, className);
  return /* @__PURE__ */ React15.createElement("div", { className: _className, ...rest }, children);
};
DrawerBody.displayName = "DrawerBody";

// ../src/drawer/drawer.ts
var Drawer = {
  OverlayDrawer,
  InlineDrawer,
  ModalDrawer,
  InlineFrame: InlineDrawerFrame,
  Container: DrawerContainer,
  Layout: DrawerLayout,
  Header: DrawerHeader,
  Body: DrawerBody,
  Footer: DrawerFooter,
  LayoutItem: DrawerLayoutItem
};
export {
  Drawer
};
